import React, { useEffect, useRef } from 'react';
import cn from 'classnames';

import { useRightSidePanelScroll } from './useRightSidePanelScroll';
import TagTabs, { TabType } from '../TagTabs/TagTabs';
import styles from './rightside-panel.module.scss';

interface IRightSidePanelProps {
  isOpen: boolean;
  onCollapse: Function;
  tabs: TabType[];
}

export default function RightSidePanel({
  isOpen,
  onCollapse,
  tabs
}: IRightSidePanelProps) {
  const panelRef = useRef<HTMLDivElement | null>(null);
  const panelBodyRef = useRef<HTMLDivElement | null>(null);
  const handleScroll = useRightSidePanelScroll(panelRef);

  const onClick = () => {
    onCollapse(!isOpen);
  };

  useEffect(() => {
    // Call handleScroll first time without scroll event
    // since need to set start position
    handleScroll();
    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  // to show the list from the beginning
  // every time when user opens Right Panel
  useEffect(() => {
    if (!isOpen && panelBodyRef.current) {
      panelBodyRef.current.scrollTo(0, 0);
    }
  }, [isOpen]);

  return (
    <div
      ref={panelRef}
      className={cn(styles['rightside-panel'], {
        [styles['rightside-panel--open']]: isOpen
      })}
    >
      <button
        type="button"
        className={styles['collapse-button']}
        onClick={onClick}
      >
        <span />
      </button>

      <div
        ref={panelBodyRef}
        className={styles.body}
      >
        {isOpen && (
          <TagTabs
            tabs={tabs}
            addQueryToUrl={false}
            contentClassName={styles.content}
            headersContainerStyle={{
              width: '100%',
              justifyContent: 'center',
              display: 'flex'
            }}
            headerContainerStyle={{
              padding: '10px 0',
              margin: 0,
              flex: '1 1 0',
              justifyContent: 'center',
            }}
            accent="viridiangreen"
            // cacheMode='after-select'
            cacheMode="no-cache"
          />
        )}
      </div>
    </div>
  );
}
